/**
 * 轮播图管理
 */
export default {
  carouselPictureList: "/carouselInfo/select", // 轮播图列表
  carouselPictureAdd: "/carouselInfo/insert", // 轮播图新增
  carouselPictureInfo: "/carouselInfo/selectDetail", // 轮播图详情
  carouselPictureEdit: "/carouselInfo/update", // 轮播图编辑
  carouselPictureSelectLiveInfoPage: "/liveInfo/selectLiveInfoPage", // 轮播图新增编辑直播课程列表
  carouselPictureSelectVideoInfoPage: "/courseInfo/selectCourseInfoPage", // 轮播图新增编辑视频课程列表
  carouselPictureSelectStudyTourInfoPage: "/studyTourInfo/selectPage", // 轮播图新增编辑游学课程列表
  newsInfoSelectPage: "/newsInfo/selectPage", // 轮播图新增编辑咨询列表
}
